import { combineReducers } from 'redux';
import { reducer as requestMagicLink } from './requestMagicLink';
import { reducer as verifyMagicLink } from './verifyMagicLink';
import { reducer as googleSignIn } from './googleSignIn';
import { reducer as updateProfile } from './updateProfile';
import { reducer as logout } from './logout';
import { reducer as refreshToken } from './refreshToken';
import { reducer as apiTokens } from './apiTokens';

// Main auth state reducer
const initialAuthState = {
  isAuthenticated: false,
  user: null,
  token: null,
  isLoading: false
};

const authState = (state = initialAuthState, action) => {
  switch (action.type) {
    case 'AUTH_VERIFY_MAGIC_LINK_SUCCESS':
    case 'AUTH_GOOGLE_SIGNIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        isLoading: false
      };
    case 'AUTH_UPDATE_PROFILE_SUCCESS':
      return {
        ...state,
        user: action.payload.user
      };
    case 'AUTH_REFRESH_TOKEN_SUCCESS':
      return {
        ...state,
        token: action.payload.token
      };
    case 'AUTH_LOGOUT_SUCCESS':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        isLoading: false
      };
    case 'AUTH_REQUEST_MAGIC_LINK_REQUEST':
    case 'AUTH_VERIFY_MAGIC_LINK_REQUEST':
    case 'AUTH_GOOGLE_SIGNIN_REQUEST':
    case 'AUTH_UPDATE_PROFILE_REQUEST':
    case 'AUTH_LOGOUT_REQUEST':
    case 'AUTH_REFRESH_TOKEN_REQUEST':
      return {
        ...state,
        isLoading: true
      };
    case 'AUTH_REQUEST_MAGIC_LINK_FAILURE':
    case 'AUTH_VERIFY_MAGIC_LINK_FAILURE':
    case 'AUTH_GOOGLE_SIGNIN_FAILURE':
    case 'AUTH_UPDATE_PROFILE_FAILURE':
    case 'AUTH_LOGOUT_FAILURE':
    case 'AUTH_REFRESH_TOKEN_FAILURE':
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

export const authReducer = combineReducers({
  authState,
  requestMagicLink,
  verifyMagicLink,
  googleSignIn,
  updateProfile,
  logout,
  refreshToken,
  apiTokens
});
